import { FormEvent, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useSessionQuery } from 'hooks/sessions';
import { useHistory, useParams } from 'react-router-dom';
import { ICreateLiveClassFormValues } from 'types/liveClass';
import CircularProgress from '@mui/material/CircularProgress';
import { useCreateLiveClassMutation } from 'hooks/liveClasses';
import CreateLiveClassForm from './components/CreateLiveClassForm';

const CreateLiveClass = () => {
  const history = useHistory();
  const { sessionid } = useParams<{ sessionid: string }>();
  const { data, isFetching, isLoading, error: errorOnFetch, refetch } = useSessionQuery(sessionid);
  const { mutateAsync: createLiveClass, isLoading: isCreating } =
    useCreateLiveClassMutation(sessionid);

  const [newLiveClass, setNewLiveClass] = useState<ICreateLiveClassFormValues | null>(null);

  const isFetchingSession = isFetching || isLoading;

  useEffect(() => {
    if (!isFetchingSession && data) {
      const basicSession = data.data;
      const { title, status, availability } = basicSession;

      setNewLiveClass({
        basicSessionId: { title, status, availability },
        title: '',
        description: '',
        link: '',
        instructorName: '',
        scheduledDateTime: '',
      });
    }
  }, [data, isFetchingSession]);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();

      if (!newLiveClass) return;
      if (newLiveClass.scheduledDateTime.length === 0) {
        toast.error('Please select a date/time');
        return;
      }

      const response = await createLiveClass(newLiveClass);

      if (response.data) {
        toast.success('Live class created successfully');
        history.push(`/dashboard/list-live-classes`);
      }
    } catch (error) {
      toast.error('Error creating live class');
    }
  };

  if (isFetchingSession)
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={30} />
      </div>
    );

  if (errorOnFetch || !newLiveClass)
    return (
      <div>
        <p>Error fetching live class data</p>
        <button
          type="button"
          onClick={() => refetch()}
          className="mt-4 btn btn-primary btn-block w-100 d-flex align-items-center justify-content-center"
        >
          Refetch
        </button>
      </div>
    );

  return (
    <div className="w-100">
      <h3>Create Live Class</h3>

      <CreateLiveClassForm
        handleSubmit={handleSubmit}
        isCreating={isCreating}
        newLiveClass={newLiveClass}
        setNewLiveClass={setNewLiveClass}
      />
    </div>
  );
};

export default CreateLiveClass;
